import Image from 'next/image';

export const FooterCertifications = () => {
  return (
    <div className="flex flex-row items-center justify-center self-center gap-8 pb-0 min-[760px]:pb-6 min-[760px]:justify-start min-[760px]:self-start">
      <div className="text-center">
        <a
          href="https://ouvidordigital.com.br/selo-ouvidor-digital/?an=Caixa+Pre+Pagos"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block"
        >
          <Image
            src="https://ouvidordigital.com.br/wp-content/uploads/2024/06/Selo-OD.svg"
            alt="Selo Ouvidor Digital - Cultura Ética"
            width={72}
            height={90}
            className="mx-auto h-auto w-14 min-[760px]:w-[72px]"
            priority={false}
          />
        </a>
        <p className="mt-2 hidden min-[760px]:block">
          <a
            href="https://ouvidordigital.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white no-underline"
          >
            <span className="block text-[6.5px] font-semibold uppercase leading-[1.4]">
              Desenvolvido por:
            </span>
            <span className="block text-[10px] leading-[1.4]">
              Ouvidor Digital
            </span>
          </a>
        </p>
      </div>

      <div className="flex flex-col items-center gap-2">
        <a
          href="https://www.reclameaqui.com.br/empresa/caixa-cartoes-pre-pagos-s-a/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block"
        >
          <Image
            src="/tagcaixa-cartao/reclame-aqui-verificada.png"
            alt="Verificada por ReclameAQUI"
            width={124}
            height={43}
            className="h-auto w-[104px] min-[760px]:w-[124px]"
            priority={false}
          />
        </a>
        <Image
          src="/Premio-RA-26-selo-redondo-1.png"
          alt="Prêmio Reclame Aqui 2026"
          width={572}
          height={600}
          className="h-auto w-[72px] min-[760px]:w-[88px]"
          priority={false}
        />
      </div>
    </div>
  );
};
